
import Vue from 'vue'
import local from './local.samples.json'
import getEnvVars from '@/common/utils/getEnvVars'

const { API_HOST } = getEnvVars()
const SAMPLES = {
  'https://development.lumiere.is': {
    channels: {
      'Network Comparison Site': 'network-comparison',
      'Hulu Binge Demo': 'hulu-binge',
    },
    activities: {
      'Tagged Feedback Test': '9V95CLKS',
      'Moment To Moment Rating': '387LZ4CB',
      'One Touch Test': 'NR4TG5GB',
      'Emoji Activity': 'Y8E4I4B7',
      'HLS Video Activity': '6CAYA4F3',
    },
  },
  'https://app.lumiere.is': {
    channels: {
      'Chris Test Channel': 'chris-test-channel',
    },
    activities: {
      'Long Video Test': 'ML9KKSA6',
    },
  },
  'http://localhost.lumiere.is': local,
}

export default Vue.extend({
  data() {
    return { samples: SAMPLES[API_HOST], host: API_HOST }
  },
})
